import Component from '@glimmer/component'
import { service } from '@ember/service'
import { ExportButton, type ExportOption } from 'district-ui-client/components/export-button/component'
import { not } from 'ember-truth-helpers'
import type ExternalRosteringService from 'district-ui-client/services/external-rostering'

interface Signature {
  Args: {
    viewMode: 'table' | 'chart'
    isDataPresent?: boolean
    emailAllStudentsCSV?: () => void
  }
  Element: HTMLDivElement
}

export class DashboardControls extends Component<Signature> {
  @service externalRostering!: ExternalRosteringService

  exportButtonWormhole = document.querySelector('#export-button-wormhole')

  get optionsToInclude(): ExportOption[] {
    const options: { table: ExportOption[]; chart: ExportOption[] } = {
      table: [
        {
          id: 'csv',
          label: 'CSV',
          icon: 'phosphor-file-x-fill',
        },
        {
          id: 'allStudentsCsv',
          label: 'CSV - All Students',
          icon: 'phosphor-envelope-simple-fill',
        },
      ],
      chart: [
        {
          id: 'print',
          label: 'Print',
          icon: 'phosphor-printer-fill',
        },
      ],
    }

    // FTP-integrated districts must not have student PII emailed so remove allStudentsCsv option
    if (this.externalRostering.source === 'ftp') {
      return options[this.args.viewMode].filter((option) => option.id !== 'allStudentsCsv')
    }

    return options[this.args.viewMode]
  }

  <template>
    <div class="flex flex-wrap items-center justify-center gap-3 print:hidden" ...attributes>
      {{#if this.exportButtonWormhole}}
        {{#in-element this.exportButtonWormhole}}
          <ExportButton
            @viewMode={{@viewMode}}
            @exportOptions={{this.optionsToInclude}}
            @disabled={{not @isDataPresent}}
            @emailAllStudentsCSV={{@emailAllStudentsCSV}}
          />
        {{/in-element}}
      {{/if}}
    </div>
  </template>
}

export default DashboardControls
